module.exports = __webpack_public_path__ + "img/89.6.CODm.e3978e73.png";